// **订单接口列表**

import base from '../base.js'; // 导入接口域名列表
import axios from '../http.js';

const members = {
    // 获取我的订单
    getOrder(params) {
        return axios.post(`${base.bds}/members/orderlist/`, params)
    },
    // 申请发票
    applyInvoice(params) {
        return axios.post(`${base.bds}/members/ordernote/`, params)
    },
    // 渠道列表
    getChannel(params) {
        return axios.get(`${base.bds}/user/channel/list/`, {
            params: params
        })
    },
    // 我的客户列表
    getCustomer(params) {
        return axios.get(`${base.bds}/user/customer/list/`, {
            params: params
        })
    },
    // 客户汇总数据
    getCustomerBox(params) {
        return axios.get(`${base.bds}/user/customer/dash/`, {
            params: params
        })
    },
    // 客户付费详情
    customerPay(params) {
        return axios.get(`${base.bds}/user/customer/pay/`, {
            params: params
        })
    },
    // 客户订单列表
    getPromotion(params) {
        return axios.get(`${base.bds}/user/customer/order/list/`, {
            params: params
        })
    },
    // 客户订单汇总
    getPromotionBox(params) {
        return axios.get(`${base.bds}/user/customer/orderdash/list/`, {
            params: params
        })
    },
    // 搜索账号
    searchAccount(params) {
        return axios.get(`${base.bds}/user/channel/bind/`, {
            params: params
        })
    },
    // 绑定渠道商
    bindingChannel(params) {
        return axios.post(`${base.bds}/user/channel/bind/`, params)
    }
}

export default members;


// WEBPACK FOOTER //
// ./src/utils/api/members.js